import * as React from 'react';

import { Button } from '@travelnest/merlin.button';
import api from '../../../../api';
import { FormInput, FormLabel, FormRow, FormSelect } from '../../form';
import { Panel } from '../../panel/Panel';
import { IAddress } from '../index';

interface IUkPostcodeLookupProps {
	onSelect(address: IAddress): any;
}

interface IUkPostcodeLookupState {
	postcode: string;
	results: string[];
	searching: boolean;
	result: string;
	message?: string;
}

// TODO: NEEDED?

export class UkPostcodeLookup extends React.Component<IUkPostcodeLookupProps, IUkPostcodeLookupState> {
	constructor(props: IUkPostcodeLookupProps) {
		super(props);
		this.state = { postcode: '', result: '', results: [], searching: false };
	}

	public async lookup(postcode: string) {
		this.setState({ searching: true });
		const result = await api.addresses.getAddressesByPostcode(postcode);
		if (result.addresses && result.addresses.length) {
			this.setState({ results: result.addresses, message: '' });
		} else {
			this.setState({ results: [], message: 'There was an error finding your address, please enter manually.' });
		}
		this.setState({ searching: false });
	}

	public change(result: string) {
		this.setState({ result });
	}

	public select(result: string) {
		const [
			line1,
			line2,
			line3,
			line4,
			,
			city
		] = result.split(',').map((r) => r.trim());

		const address: IAddress = {
			address1: `${line1 ? line1 : ''}${line1 && line2 ? ', ' : ''}${line2 || ''}`,
			address2: `${line3 ? line3 : ''}${line3 && line4 ? ', ' : ''}${line4 || ''}`,
			city,
			postcode: this.state.postcode,
			country_code: 'GB'
		};

		this.props.onSelect(address);
		this.setState({ results: [] });
	}

	public addressTransformer(address: string) {
		const prettyAddress = address.trim().replace(/ ,/gi, '').replace(/,+$/, '');
		return prettyAddress;
	}

	public render() {
		return <div className="uk-postcode-lookup">
			<FormRow>
				<div className="uk-postcode-lookup__row">
					<FormLabel htmlFor="postcode">UK Postcode</FormLabel>
					<div className="uk-postcode-lookup__input">
						<FormInput
							onChange={(e) => this.setState({ postcode: e.target.value })}
							type="text"
							required
							name="postcode"
							id="postcode"
							value={this.state.postcode || ''} />
					</div>
					<Button
						loading={this.state.searching}
						disabled={!this.state.postcode}
						onClick={(e) => { e.preventDefault(); this.lookup(this.state.postcode); }}>Find address</Button>
				</div>
			</FormRow>
			{this.state.message && <Panel type="error" withIcon={true}>{this.state.message}</Panel>}
			{!(this.state.results && this.state.results.length) ? null : <FormRow>
				<div className="uk-postcode-lookup__row">
					<FormSelect widthtype="wide" required name="addresses" onChange={(e) => this.change(e.target.value)}>
						<option value="">Select address</option>
						{this.state.results.map((result, i) => <option key={`option-${i}`} value={result} label={this.addressTransformer(result)}>{result}</option>)}
					</FormSelect>
					<Button disabled={!this.state.result} onClick={() => this.select(this.state.result)}>Select address</Button>
				</div>
			</FormRow>}
		</div>;
	}
}
